import template from './floor-commercial.jade';

export default angular.module('cian.addForm.floorCommercial', []).directive('cianAfAboutObjectFloorCommercial', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller() {
    this.minFloorNumber = -3;
  },
  controllerAs: 'floor',
  template,
})).name;
